<template>
  <div id="nav" class="relative navig z-30">
    <div id="addc" class="absolute top-0 left-0 right-0 bottom-0">

    </div>
    <div class="border-nav w-screen overflow-hidden relative z-40 px-8">
      <div class="container py-4 lg:py-8 relative back transition-all ease-in-out duration-300">
        <div class="md:w-full relative flex justify-between items-center lg:gap-x-12">
          <div class="relative mb-0">
            <slot name="brand" />
          </div>
          <div class="h-6">
            <button name="main menu" aria-label="main menu" type="button" @click="isMenu = !isMenu; isActive = !isActive; isSlid = true; isSlid = true;addo();addh();addbg();whitet();addoanim();" class="text-center text-primary toggle-me">
              <div id="nav-icon4" :class="{ open: isActive }">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ desktopmenu: isActive }"  class="absolute overflow-hidden z-30 main-show w-screen block h-screen bg-primary top-0 right-0 left-0 bottom-0 invisi">
      <div class="relative h-screen lg:block hidden">
        <img src="/app/themes/wordpress/assets/images/menu-shapeb.svg" alt="eye shape" class="absolute hidden lg:block lg:-bottom-32 -right-28 2xl:-right-20 2xl:bottom-8" style="width:50%;">
        <div class="w-screen left-0 transition-all ease-in-out duration-300 mover h-screen flex items-start absolute lg:pt-32 mx-auto px-4 lg:px-8 py-4 lg:py-8">
          <div class="grid grid-cols-4 container gap-x-12">
            <div>
              <p class="text-white text-18 leading-24 font-bold uppercase">Conditions</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenuec" />
            </div>
            <div>
              <p class="text-white text-18 leading-24 font-bold uppercase">Eyelid Surgery</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenues" />
              <p class="text-white text-18 leading-24 font-bold mt-6 uppercase">Lacrimal Surgery</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenuls" />
            </div>
            <div>
              <p class="text-white text-18 leading-24 font-bold uppercase">Orbital Surgery</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenuos" />
              <p class="text-white text-18 leading-24 font-bold mt-6 uppercase">Cosmetic Treatments</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenuct" />
            </div>
            <div>
              <p class="text-white text-18 leading-24 font-bold uppercase">Your Surgeon</p>
              <div class="h-4 w-34 bg-white mt-3 mb-6"></div>
              <slot name="mainmenu" />
            </div>
          </div>
        </div>
      </div>
      <!--      split-->
      <div class="relative h-screen lg:hidden">
        <div class="w-screen left-0 overflow-y-scroll overflow-x-hidden scrollers transition-all ease-in-out duration-300 mover h-screen items-center absolute mx-auto px-4 lg:px-8 py-4 lg:py-8">
          <div class="w-full relative overflow-y-scroll overflow-x-hidden">
            <ul class="accordion-list space-y-2 mt-24 pb-32">
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Eye Conditions</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>

                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenuec" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Cataract</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenucat" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Eyelid Surgery</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenues" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Lacrimal Surgery</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenuls" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Orbital Surgery</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenuos" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Cosmetic Treatments</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenuct" />
                </div>
              </li>
              <li class=" border-b border-tertiary">
                <div class="w-full clickavle gap-x-2 pb-4 mt-4 flex justify-between items-center cursor-pointer">
                  <span class="text-white font-bold text-18 uppercase">Your Surgeon</span>
                  <div class="w-8">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </div>
                <div class="answer py-4">
                  <slot name="mainmenu" />
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isOpen: false,
      isOpenLeft: false,
      services:false,
      isActive: false,
      isSlid: true,
      isMenu: false,
    }
  },
  methods: {
    addo () {
      document.querySelector('body').classList.toggle('overflow-hidden')
    },
    addom () {
      document.querySelector('.desktopmenu').classList.toggle('offscreen')
    },
    whitet () {
      document.querySelector('.navig').classList.toggle('whitenavig')
    },
    addomt () {
      document.querySelector('.moverin').classList.toggle('onscreen')
    },
    addoanim () {
      document.querySelector('.menu-item').classList.toggle('test')
    },
    addh () {
      document.querySelector('body').classList.toggle('max-h-screen')
    },
    addbg () {
      document.querySelector('.border-nav').classList.toggle('bg-primary')
    },
    removeo () {
      document.querySelector('body').classList.toggle('overflow-hidden')
    },
    removeh () {
      document.querySelector('body').classList.toggle('max-h-screen')
    },
  }
}
</script>
<style lang="scss">
.moverin{
  right: -101vw;
}
.onscreen{
  right: 0!important;
}
.offscreen .mover{
  left: -101vw!important;
}
.invisi{
  margin-left: -105vw;
  transition: ease-in-out 0.5s all;
}
.invisit{
  margin-left: -105vw;
  transition: ease-in-out 0.5s all;
}
.invisib{
  margin-left: -200vw;
  transition: ease-in-out 0.5s all;
}
.desktopmenu{
  margin-left: 0;
}
.slideit{
  animation: slideit 1.5s;
}

@keyframes slideit {
  0% {
    margin-left: -105vw;
  }
  30% {
    margin-left: 0;
  }
  70%{
    margin-left: 0;
  }
  100% {
    margin-left: 105vw;
  }
}
</style>
